export class AdminRating {
    id!: string;
    rate!: number;
    disturbingRate!: number;

    constructor(
        id: string,
        rate: number,
        disturbingRate: number) {
            this.id = id;
            this.rate = rate;
            this.disturbingRate = disturbingRate;
    }
}